import { NOTIFICATION_ACTIONS } from "./actions";

const initialState = {
  notifications: [],
  unreadCount: 0,
  loading: false,
  error: null,
  fcmToken: null,
  notificationPermission: null,
  pagination: {
    current_page: 1,
    last_page: 1,
    per_page: 15,
    total: 0,
  },
};

const notificationReducer = (state = initialState, action) => {
  switch (action.type) {
    // Fetch notifications
    case NOTIFICATION_ACTIONS.FETCH_NOTIFICATIONS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case NOTIFICATION_ACTIONS.FETCH_NOTIFICATIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        notifications: action.payload.data || [],
        pagination: {
          current_page: action.payload.current_page || 1,
          last_page: action.payload.last_page || 1,
          per_page: action.payload.per_page || 15,
          total: action.payload.total || 0,
        },
        error: null,
      };

    case NOTIFICATION_ACTIONS.FETCH_NOTIFICATIONS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // Fetch unread count
    case NOTIFICATION_ACTIONS.FETCH_UNREAD_COUNT_REQUEST:
      return {
        ...state,
        error: null,
      };

    case NOTIFICATION_ACTIONS.FETCH_UNREAD_COUNT_SUCCESS:
      return {
        ...state,
        unreadCount: action.payload,
        error: null,
      };

    case NOTIFICATION_ACTIONS.FETCH_UNREAD_COUNT_FAILURE:
      return {
        ...state,
        error: action.payload,
      };

    // Mark as read
    case NOTIFICATION_ACTIONS.MARK_AS_READ_REQUEST:
      return {
        ...state,
        error: null,
      };

    case NOTIFICATION_ACTIONS.MARK_AS_READ_SUCCESS:
      return {
        ...state,
        notifications: state.notifications.map((notification) =>
          notification.id === action.payload
            ? {
                ...notification,
                is_read: true,
                read_at: new Date().toISOString(),
              }
            : notification
        ),
        unreadCount: Math.max(0, state.unreadCount - 1),
        error: null,
      };

    case NOTIFICATION_ACTIONS.MARK_AS_READ_FAILURE:
      return {
        ...state,
        error: action.payload.error,
      };

    // Mark all as read
    case NOTIFICATION_ACTIONS.MARK_ALL_AS_READ_REQUEST:
      return {
        ...state,
        error: null,
      };

    case NOTIFICATION_ACTIONS.MARK_ALL_AS_READ_SUCCESS:
      return {
        ...state,
        notifications: state.notifications.map((notification) => ({
          ...notification,
          is_read: true,
          read_at: new Date().toISOString(),
        })),
        unreadCount: 0,
        error: null,
      };

    case NOTIFICATION_ACTIONS.MARK_ALL_AS_READ_FAILURE:
      return {
        ...state,
        error: action.payload,
      };

    // Delete notification
    case NOTIFICATION_ACTIONS.DELETE_NOTIFICATION_REQUEST:
      return {
        ...state,
        error: null,
      };

    case NOTIFICATION_ACTIONS.DELETE_NOTIFICATION_SUCCESS:
      const deletedNotification = state.notifications.find(
        (n) => n.id === action.payload
      );
      return {
        ...state,
        notifications: state.notifications.filter(
          (notification) => notification.id !== action.payload
        ),
        unreadCount:
          deletedNotification && !deletedNotification.is_read
            ? Math.max(0, state.unreadCount - 1)
            : state.unreadCount,
        error: null,
      };

    case NOTIFICATION_ACTIONS.DELETE_NOTIFICATION_FAILURE:
      return {
        ...state,
        error: action.payload.error,
      };

    // Create notification
    case NOTIFICATION_ACTIONS.CREATE_NOTIFICATION_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case NOTIFICATION_ACTIONS.CREATE_NOTIFICATION_SUCCESS:
      return {
        ...state,
        loading: false,
        notifications: [action.payload, ...state.notifications],
        error: null,
      };

    case NOTIFICATION_ACTIONS.CREATE_NOTIFICATION_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // Send broadcast
    case NOTIFICATION_ACTIONS.SEND_BROADCAST_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case NOTIFICATION_ACTIONS.SEND_BROADCAST_SUCCESS:
      return {
        ...state,
        loading: false,
        notifications: [action.payload, ...state.notifications],
        error: null,
      };

    case NOTIFICATION_ACTIONS.SEND_BROADCAST_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // Real-time notifications
    case NOTIFICATION_ACTIONS.ADD_REAL_TIME_NOTIFICATION:
      return {
        ...state,
        notifications: [action.payload, ...state.notifications],
        unreadCount: state.unreadCount + 1,
      };

    case NOTIFICATION_ACTIONS.UPDATE_NOTIFICATION:
      return {
        ...state,
        notifications: state.notifications.map((notification) =>
          notification.id === action.payload.id
            ? { ...notification, ...action.payload }
            : notification
        ),
      };

    case NOTIFICATION_ACTIONS.REMOVE_NOTIFICATION:
      const removedNotification = state.notifications.find(
        (n) => n.id === action.payload
      );
      return {
        ...state,
        notifications: state.notifications.filter(
          (notification) => notification.id !== action.payload
        ),
        unreadCount:
          removedNotification && !removedNotification.is_read
            ? Math.max(0, state.unreadCount - 1)
            : state.unreadCount,
      };

    // FCM token and permission
    case NOTIFICATION_ACTIONS.SET_FCM_TOKEN:
      return {
        ...state,
        fcmToken: action.payload,
      };

    case NOTIFICATION_ACTIONS.SET_NOTIFICATION_PERMISSION:
      return {
        ...state,
        notificationPermission: action.payload,
      };

    default:
      return state;
  }
};

export default notificationReducer;
